@if (templateId && businessUnitId) {
  @switch (type()) {
    @case (trustBox.List) {
      <div
        #trustboxElementRef
        [attr.data-businessunit-id]="businessUnitId"
        [attr.data-font-family]="fontFamily"
        [attr.data-template-id]="templateId"
        [attr.data-text-color]="textColor"
        [attr.data-theme]="theme()"
        class="trust-box trust-box--list"
        data-locale="en-GB"
        data-stars="4,5"
        data-style-height="600px"
        data-style-width="100%"
        data-test-hook="trust-box-list"
      ></div>
    }
    @case (trustBox.MiniCarousel) {
      <div
        #trustboxElementRef
        [attr.data-businessunit-id]="businessUnitId"
        [attr.data-font-family]="fontFamily"
        [attr.data-template-id]="templateId"
        [attr.data-text-color]="textColor"
        [attr.data-theme]="theme()"
        class="trust-box trust-box--mini-carousel"
        data-locale="en-GB"
        data-stars="4,5"
        data-style-height="280px"
        data-style-width="100%"
        data-test-hook="trust-box-mini-carousel"
      ></div>
    }
    @case (trustBox.Slider) {
      <div
        #trustboxElementRef
        [attr.data-businessunit-id]="businessUnitId"
        [attr.data-font-family]="fontFamily"
        [attr.data-template-id]="templateId"
        [attr.data-text-color]="textColor"
        [attr.data-theme]="theme()"
        class="trust-box trust-box--slider"
        data-locale="en-GB"
        data-stars="4,5"
        data-style-height="240px"
        data-style-width="100%"
        data-test-hook="trust-box-slider"
      ></div>
    }
    @case (trustBox.Combo) {
      <div
        #trustboxElementRef
        [attr.data-businessunit-id]="businessUnitId"
        [attr.data-font-family]="fontFamily"
        [attr.data-template-id]="templateId"
        [attr.data-text-color]="textColor"
        [attr.data-theme]="theme()"
        class="trust-box trust-box--combo"
        data-locale="en-GB"
        data-style-width="100%"
        data-test-hook="trust-box-combo"
      ></div>
    }
    @default {
      <div
        #trustboxElementRef
        [attr.data-businessunit-id]="businessUnitId"
        [attr.data-font-family]="fontFamily"
        [attr.data-template-id]="templateId"
        [attr.data-text-color]="textColor"
        [attr.data-theme]="theme()"
        attr.data-test-hook="trust-box-{{ type() }}"
        class="trust-box trust-box--{{ type() }}"
        data-locale="en-GB"
        data-style-width="100%"
      ></div>
    }
  }
}
